import { Component, OnInit, Output,Input ,EventEmitter,Injector } from '@angular/core';
import { MatTableDataSource,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS} from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Proforma } from '../../../../models/Proforma';
import { Router,ActivatedRoute } from '@angular/router';
import Swal from "sweetalert2";
import { DatePipe} from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus } from '../../../../models/messages';
import { ProformaService } from '../../../../services/operaciones/proforma/proforma.service';
import { EmpresasService } from '../../../../services/empresas/empresas.service';
import { OperacionService } from '../../../../services/operaciones/operacion/operacion.service';
import { LoginService } from 'app/services/login/login.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Console } from 'console';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
declare var $: any;
@Component({
  selector: 'app-generar-operacion',
  templateUrl: './generar-operacion.component.html',
  styleUrls: ['./generar-operacion.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,MessagesStatus,Proforma,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class GenerarOperacionComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Proforma=environment.LABEL_PROFORMA;
  Label_Proformas=environment.LABEL_PROFORMAS;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  idEmpresa : number = 0;
  idContratoMarco : string;
  dataContract : any = [];
  user:any;
  operaciones : any = [];
  operacionesDet : any =[];
  rProvCombo : any =[];
  rProvArray : any =[];
  rRefBancariaArray : any =[];
  rProvEmail : string;
  rProvRefBancarias : any =[];
  prov: boolean = false;

  Simboloi : string;
  tipoServicio : any;
  ProformaTotales:any=[];

  loading:boolean=false;

  selected = "21575773";

  Codigo_Orden: any = 'Test-123';


  @Input() proforma : Proforma;
  @Output() cerrarGenerarOperacion: EventEmitter<boolean>;

  formularioGenerarOperacion : FormGroup;
  formularioCrearOperacion : FormGroup;

  dataSource :any;
  displayedColumns: string[] = 
  ['Documento',
  'Fecha_Pago',
  'Plazo',
  'VNPP',
  'Adelanto',
  'Interes',
  'Comision',
  'IGV',
  'Desembolso',
  'Remanente'];
  operacionService:OperacionService;
  empresasService:EmpresasService;
  proformaService:ProformaService;
  loginService:LoginService
  constructor(
    private injector:Injector,
    private datepipe :DatePipe,
    private routerActive:ActivatedRoute,
    private router:Router,
    private msgTitulos : MessagesTitles,
    private msgStatus:MessagesStatus
    
    ) { 
    this.operacionService = this.injector.get<OperacionService>(OperacionService);
    this.empresasService = this.injector.get<EmpresasService>(EmpresasService);
    this.proformaService = this.injector.get<ProformaService>(ProformaService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.routerActive.params.subscribe( params => {
    this.cerrarGenerarOperacion = new EventEmitter(); 
    this.tipoServicio = this.Id_Factoring; 
    })

    this.formularioGenerarOperacion = new FormGroup({
      "idProforma":new FormControl('',  Validators.required),
      "idUser":new FormControl(''),
      "idProveedor": new FormControl('',  Validators.required),
      "Proveedor": new FormControl('',  Validators.required),
      "Adquirente": new FormControl('',  Validators.required),
      "MonedaDescripcion": new FormControl('',  Validators.required),
      "Fecha_Maxima_Desembolso": new FormControl('',  Validators.required),
      "Adelanto":new FormControl('',  Validators.required),
      "TEM":new FormControl('',  Validators.required),
      "RepresentanteProv1":new FormControl('', Validators.required),
      "RepresentanteProv2":new FormControl('', Validators.required),
      "RepresentanteIF":new FormControl('', Validators.required),
      "RepresentanteInnova":new FormControl(''),
      "ReferenciasBancariasProv":new FormControl('', Validators.required),
      "ReferenciasBancariasDetProv":new FormControl('', Validators.required),
      "provCorreoElectronico1":new FormControl('', Validators.required),
      "provCorreoElectronico2":new FormControl(''),
      "Codigo_Orden":new FormControl('') 
      });

      this.formularioCrearOperacion = new FormGroup({
        idProforma :new FormControl(''),
        idUsuario :new FormControl(''),
        idRepresentanteProv1 :new FormControl(''),
        idRepresentanteProv2 :new FormControl(''),
        idRepresentanteIF :new FormControl(''),
        idCuenta :new FormControl(''),
        bancoDetalle :new FormControl(''),
        Tipo_Servicio :new FormControl(''),
        Porcentaje_Interes_Adquirente :new FormControl(''),
        Codigo_Orden :new FormControl(''), 
      });
  }

  ngOnInit() { 
    this.obtenerContratosMarco(this.proforma.idProveedor.toString(),this.proforma.Tipo_Servicio);
    this.formularioGenerarOperacion.controls['idUser'].setValue(this.user.Usuario);
    this.formularioGenerarOperacion.controls['idProforma'].setValue(this.proforma.idProforma);
    this.formularioGenerarOperacion.controls['idProveedor'].setValue(this.proforma.idProveedor);
    this.formularioGenerarOperacion.controls['Proveedor'].setValue(this.proforma.NombreProveedor);
    this.formularioGenerarOperacion.controls['Adquirente'].setValue(this.proforma.NombreAdquirente);
    this.formularioGenerarOperacion.controls['MonedaDescripcion'].setValue(this.proforma.NombreAdquirente);
    this.formularioGenerarOperacion.controls['RepresentanteInnova'].setValue(this.selected);
    if (this.proforma.Moneda == this.Label_id_dolares){
      this.formularioGenerarOperacion.controls['MonedaDescripcion'].setValue("Dolares");
      this.Simboloi = "DOLARES";
    } else {
      this.formularioGenerarOperacion.controls['MonedaDescripcion'].setValue("Soles");
      this.Simboloi = "SOLES";
    }
    this.formularioGenerarOperacion.controls['Fecha_Maxima_Desembolso'].setValue(this.datepipe.transform(this.proforma.Fecha_Desembolso,'dd-MM-yyyy'));

    this.formularioGenerarOperacion.controls['Adelanto'].setValue(this.proforma.Adelanto_porcentaje.toFixed(2) + " %");
    this.formularioGenerarOperacion.controls['TEM'].setValue(this.proforma.TEM.toFixed(2) + " %");

    this.ListarProformaDetalle(this.proforma.idProforma);
    if(this.proforma.Tipo_Servicio == 1489){

      this.ListarRepresentantesProv(this.proforma.idFactor);
      this.ListarReferenciasBancarias(this.proforma.idFactor);
    }else{
      
      this.ListarRepresentantesProv(this.proforma.idProveedor);
      this.ListarReferenciasBancarias(this.proforma.idProveedor);
    }
  }

  obtenerContratosMarco(idEmpresa,tipoServicio){
    let operacion :any;
    let text : string = "";
    let mostrar : boolean = false;
    this.empresasService.obtenerContratosMarco(idEmpresa,tipoServicio)
    .subscribe(res => {
      operacion = res; 
      operacion = operacion.filter(
        state => state.Estado.toLowerCase().indexOf("a") === 0
      );

      if (operacion.length > 1){
        mostrar = true;
        text = "Validar contrato marco del "+this.Label_Proveedor.toLowerCase()+".";
      } else if (operacion.length === 0) {
        mostrar = true;
        text = this.Label_Proveedor+" no cuenta con contrato marco.";
      }
      
      if(tipoServicio == this.Id_Confirming || tipoServicio == 1489){
        mostrar = false;
      }

      if(mostrar){
        Swal.fire({
          title: "¡Alto!",
          text: text,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
        this.CerrarPopUp();
      } else {
        this.idContratoMarco = operacion[0].IDCMarco;
        this.showNotification('success','top','right','Contrato marco vigente hasta el ' + operacion[0].Fecha_Final +'.');
      }
    },(err: HttpErrorResponse)=> {
      this.loading = false;
      if (err.error instanceof ErrorEvent) {
        console.error("Error Event");
      } else {
          this.msgStatus.getMessage(err.status);
      }
    });
  }

  CerrarPopUp(){
    this.cerrarGenerarOperacion.emit();
  }

  ListadoOperacionesFiltros() {
    this.loading = true;
    
    this.proformaService.obtenerProformaOperacion()                                            
    .subscribe(
        res => {       
            this.operaciones = res;
            this.dataSource = new MatTableDataSource(this.operaciones);
            this.loading = false;
        } , err =>{
            Swal.fire({
              title: "¡Algo salió mal!",
              text:  err.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false
            });        
          this.loading = false;
        }
    )
  }

  ListarProformaDetalle(idProforma){
    this.loading = true;
    this.proformaService.obtenerProformaDetalle(idProforma)                                            
    .subscribe(
        res => {       
            this.operacionesDet = res;
            this.calcularTotalesImporte();
            this.loading = false;
        } , err1 =>{
            Swal.fire({
              title: "¡Algo salió mal!",
              text:  err1.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false
            });        
          this.loading = false;
        }
    )
  }

  ListarRepresentantesProv(idProvi){
    this.loading = true;
    this.empresasService.obtenerContactosEmpresa(idProvi)                                            
    .subscribe(
        res => {       
            this.rProvCombo = res;
            this.rProvCombo = this.rProvCombo.filter(
              state => state.Des_Estado.toLowerCase().indexOf('activo') === 0 
            );
            this.loading = false;
        } , err2 =>{
            Swal.fire({
              title: "¡Algo salió mal!",
              text:  err2.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false
            });        
          this.loading = false;
        }
    )
  }

  ListarReferenciasBancarias(idProvi){
    this.loading = true;
    this.empresasService.obtenerReferenciasBancariasEmpresa(idProvi).subscribe(
        res => {  
          console.log("RefBan",res);
          console.log("servv",this.tipoServicio);
          console.log("simnn",this.Simboloi);
            
            this.rProvRefBancarias = res;
            this.rProvRefBancarias = this.rProvRefBancarias.filter(              
              state => state.Moneda_Dsc.toLowerCase().indexOf(this.Simboloi.toLowerCase()) === 0 && 
                       state.Estado.toLowerCase().indexOf("activo") === 0 && state.Tipo_Servicio == this.tipoServicio
            );
            console.log("bancc",this.rProvRefBancarias);
            this.loading = false;
        } , err3 =>{
            Swal.fire({
              title: "¡Algo salió mal!",
              text:  err3.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false
            });        
          this.loading = false;
        }
    )
  }

  SetearCorreo1(idContacto){
    this.prov = false;
    if(this.rProvCombo.length > 0){
      this.rProvArray = this.rProvCombo.filter(
        state => state.idContacto == idContacto
      );
      this.formularioGenerarOperacion.controls['provCorreoElectronico1'].setValue(this.rProvArray[0].Correo);
      this.formularioGenerarOperacion.controls['RepresentanteProv1'].setValue(this.rProvArray[0].idContacto);
      if(this.formularioGenerarOperacion.get('RepresentanteProv2').value  == this.formularioGenerarOperacion.get('RepresentanteProv1').value){
        this.prov = true;
      }else{
        this.prov = false;
      }
    }
  }

  SetearCorreo2(idContacto){
    this.prov = false;
    if(idContacto === undefined){
      this.formularioGenerarOperacion.controls['provCorreoElectronico2'].setValue('');
      this.formularioGenerarOperacion.controls['RepresentanteProv2'].setValue(0);
    } else {
      if(this.rProvCombo.length > 0){
        this.rProvArray = this.rProvCombo.filter(
          state => state.idContacto == idContacto
        );
        this.formularioGenerarOperacion.controls['provCorreoElectronico2'].setValue(this.rProvArray[0].Correo);
        this.formularioGenerarOperacion.controls['RepresentanteProv2'].setValue(this.rProvArray[0].idContacto);
        if(this.formularioGenerarOperacion.get('RepresentanteProv2').value  == this.formularioGenerarOperacion.get('RepresentanteProv1').value){
          this.prov = true;
        }else{
          this.prov = false;
        }   
      }
    }
  }

  SetearRefBancaria(idCuenta){
    console.log("REFF",this.rProvRefBancarias);
    if(this.rProvRefBancarias.length > 0){
      this.rRefBancariaArray = this.rProvRefBancarias.filter(
        state => state.idCuenta == idCuenta
      );
      //A|19193687396130|BCP|D|00219119368739613058|325
      this.formularioGenerarOperacion.controls['ReferenciasBancariasProv'].setValue(this.rRefBancariaArray[0].idCuenta);
      let descripcionBanco = 
        ((this.rRefBancariaArray[0].Tipo_de_Cuenta == 90) ? "A":"C")+"|"+
        this.rRefBancariaArray[0].NroCuenta+"|"+
        this.rRefBancariaArray[0].Banco_Dsc+"|"+
        ((this.rRefBancariaArray[0].Moneda == this.Label_id_dolares) ? "D":"S")+"|"+
        this.rRefBancariaArray[0].CCI+"|"+
        this.rRefBancariaArray[0].idCuenta;
      this.formularioGenerarOperacion.controls['ReferenciasBancariasDetProv'].setValue(descripcionBanco);
    }
  }

  SetearRepIF(idRepresentanteIF){
    this.formularioGenerarOperacion.controls['RepresentanteInnova'].setValue(idRepresentanteIF);
  }

  calcularTotalesImporte(){
    let TotalDoc :number = 0;
    let TotalVNPP :number = 0;
    let TotalAdelanto : number = 0;
    let TotalIGV : number = 0;
    let TotalInteres : number = 0;
    let TotalComision : number = 0;
    let TotalDesembolso : number = 0;
    let TotalRemanente : number = 0;    
    for (let item of this.operacionesDet) {
      TotalDoc += 1;
      TotalVNPP += Number(item.VNPP) ; 
      TotalAdelanto += Number(item.Adelanto_importe);
      TotalInteres += Number(item.Interes_importe);
      TotalComision += Number(item.Comision_importe);
      TotalIGV += Number(item.IGV_Importe);
      TotalDesembolso += Number(item.Desembolso_importe);
      TotalRemanente += Number(item.Remanente_importe);      
    }
    this.ProformaTotales.Docs = TotalDoc;
    this.ProformaTotales.VNPP = TotalVNPP;
    this.ProformaTotales.Adelanto = TotalAdelanto;
    this.ProformaTotales.Interes = TotalInteres;
    this.ProformaTotales.Comision = TotalComision;
    this.ProformaTotales.IGV_TOTAL = TotalIGV;
    this.ProformaTotales.Desembolso = TotalDesembolso;
    this.ProformaTotales.Remanente = TotalRemanente;
    
  }

  guardarOperacion(){
    this.formularioCrearOperacion.controls['idProforma'].setValue(this.formularioGenerarOperacion.controls['idProforma'].value);
    this.formularioCrearOperacion.controls['idUsuario'].setValue(this.formularioGenerarOperacion.controls['idUser'].value);
    this.formularioCrearOperacion.controls['idRepresentanteProv1'].setValue(this.formularioGenerarOperacion.controls['RepresentanteProv1'].value);
    this.formularioCrearOperacion.controls['idRepresentanteProv2'].setValue(this.formularioGenerarOperacion.controls['RepresentanteProv2'].value == "" ? "" : this.formularioGenerarOperacion.controls['RepresentanteProv2'].value);
    this.formularioCrearOperacion.controls['idRepresentanteIF'].setValue(this.formularioGenerarOperacion.controls['RepresentanteInnova'].value);
    this.formularioCrearOperacion.controls['idCuenta'].setValue(this.formularioGenerarOperacion.controls['ReferenciasBancariasProv'].value);
    this.formularioCrearOperacion.controls['bancoDetalle'].setValue(this.formularioGenerarOperacion.controls['ReferenciasBancariasDetProv'].value);
    this.formularioCrearOperacion.controls['Tipo_Servicio'].setValue(this.proforma.Tipo_Servicio);
    this.formularioCrearOperacion.controls['Porcentaje_Interes_Adquirente'].setValue(this.proforma.Porcentaje_Interes_Adquirente);
    this.formularioCrearOperacion.controls['Codigo_Orden'].setValue(this.formularioGenerarOperacion.controls['Codigo_Orden'].value);
    
    
    Swal.fire({
      title: "Espere",
      text: "Guardando información",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading(); 
    this.operacionService.guardarOperacion(this.formularioCrearOperacion.getRawValue()).subscribe( 
      res => {
      Swal.fire({
        title: "Success",
        text: "Operación registrado correctamente",
        type: "success",
        allowOutsideClick: false,
        heightAuto: false
      }).then(resp => {
        if (resp.value == true) {
          this.loginService.clickGuard = true;
          this.router.navigate(["/operaciones/operacion/listado"]);
        }
      });
      },err =>  {
        if(err.error.code == 500){
          err.error.error = "Problemas con el sistema, por favor contactarse con soporte"
        }
        Swal.fire({
          title: this.msgTitulos.Error_Algo_Salio_Mal,
          text: err.error.error,
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    )                      
  }

  showNotification(type,from,align,message){
        $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}
